import { defineStore } from 'pinia';

export const useWalletTransferFormStore = defineStore('wallet-transfer-form', {
  state: () => ({
    draft: null
  }),
  actions: {
    saveDraft(payload = {}) {
      this.draft = {
        addressTo: String(payload.addressTo || ''),
        recipientType: payload.recipientType === 'userId' ? 'userId' : 'address',
        amount: String(payload.amount || '')
      };
    },
    consumeDraft() {
      const draft = this.draft ? { ...this.draft } : null;
      this.draft = null;
      return draft;
    },
    clearDraft() {
      this.draft = null;
    }
  }
});
